<template>
  <div>
    <div class="text-center depahead rsu">Register</div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <div style="height: 60px; padding-top: 10px">
        <v-img
          style="margin-left: auto; margin-right: auto"
          width="80px"
          src="../../assets/depa.png"
        ></v-img>
      </div>
      <v-container>
        <ValidationObserver ref="observer">
          <div class="depatitle">กรอก E-mail หรือ เบอร์โทร</div>
          <ValidationProvider
            name="อีเมล"
            key="email"
            :rules="{ required: true }"
            v-slot="{ errors }"
          >
            <v-radio-group
              @change="
                $store.state.input.username = '';
                $refs.observer.reset();
              "
              :error-messages="errors"
              v-model="$store.state.typecb"
              column
              row
            >
              <v-radio value="email">
                <template v-slot:label>
                  <span
                    style="font-size: 25px; font-weight: 600"
                    class="primary--text"
                  >
                    E-mail
                  </span>
                </template>
              </v-radio>
              <v-radio value="phone">
                <template v-slot:label>
                  <span
                    style="font-size: 25px; font-weight: 600"
                    class="primary--text"
                  >
                    เบอร์โทร
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
          </ValidationProvider>

          <div class="mt-5">
            <ValidationProvider
              :name="$store.state.typecb == 'email' ? 'อีเมล' : 'เบอร์โทร'"
              key="email"
              :rules="{ required: true, email: $store.state.typecb == 'email' }"
              v-slot="{ errors }"
            >
              <v-text-field
                :key="'email'"
                v-if="$store.state.typecb == 'email'"
                name="email"
                :placeholder="`กรอกอีเมล`"
                :error-messages="errors"
                dense
                v-model="$store.state.input.username"
                outlined
                style="border-radius: 6px"
              ></v-text-field>
              <v-text-field
                v-else
                name="phoneno"
                :key="'phoneno'"
                :placeholder="'กรอกเบอร์โทร'"
                type="tel"
                v-mask="'##-####-####'"
                :error-messages="errors"
                dense
                v-model="$store.state.input.username"
                outlined
                style="border-radius: 6px"
              ></v-text-field>
            </ValidationProvider>
          </div>
          <div class="submitbtn">
            <v-btn
              depressed
              @click="next"
              class="text-capitalize"
              color="primary"
              block
              >Next</v-btn
            >
          </div>
        </ValidationObserver>
        <!-- <div>
          <v-dialog fullscreen v-model="term">
            <v-card> <Term @close="term = false"></Term> </v-card>
          </v-dialog>
        </div> -->
      </v-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Term from "./Term.vue";
export default {
  data() {
    return {
      term: true,

      input: {
        username: "",
        usertype: "",
      },
    };
  },
  components: {
    Term,
  },
  methods: {
    async next() {
      var isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.$store.state.registerType = this.$store.state.typecb;
        if (this.$store.state.typecb == "phone") {
          this.$store.state.input.username = this.$store.state.input.username.replace(
            /-/g,
            ""
          );
        } else {
          this.$store.state.input.username = this.$store.state.input.username.toLowerCase()
        }

        this.query.view = "OTP";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>